module.exports = __webpack_public_path__ + "media/operational-monitoring_de_ipad_new.3019d100.mp4";